import { ReservationSearchCriteria } from './reservation-search-criteria';

export class Criteria {
    criteriaId: number;
    name: string;
    criteria: ReservationSearchCriteria;
    userId: number;
}